import React from 'react'
import App, { Container } from 'next/app'
import Header from '../components/Header.js';
import Footer from '../components/Footer.js';
import Modal from '../components/Modal.js';
import { ModalContext } from '../context/modal';
import Head from 'next/head';
import { initGA, logPageView, logEvent } from '../utils/analytics';
import 'mdn-polyfills/String.prototype.includes';

// using this instead of a traditonal layout, so React.Context will work. Also, this is a default layout and doesn't need to be manually included across the site

class Layout extends React.Component {
  constructor(props) {
    super(props);
    
    this.state = {
      modalData: '',
      currentModal: '',
      currentSearch: null,
      darkMode: this.props.darkMode,
      entryData: {entries: [],},
      nextPageLink: undefined,
    };
  }

  updateValue = (key, val) => {
		this.setState({[key]: val});
  }

  componentDidMount() {
    if(this.state.darkMode === true) {
      logEvent('initial appearance', 'dark');
    } else {
      logEvent('initial appearance', 'light');
    }
  }
  
  render () {
    const { children } = this.props;

    return (
      <ModalContext.Provider value={{updateValue: this.updateValue, darkMode: this.state.darkMode, modalData: this.state.modalData, currentModal: this.state.currentModal, currentSearch: this.state.currentSearch, entryData: this.state.entryData, nextPageLink: this.state.nextPageLink}}>
        <Head>
          <meta httpEquiv="X-UA-Compatible" content="IE=edge"></meta>
          <link rel="shortcut icon" href="https://d3alngem7je9z2.cloudfront.net/favi-64.ico" type="image/x-icon"></link>
          <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no"></meta>
          <meta name="keywords" content="website inspiration, website design inspiration, web design gallery, web design, webdesign, inspiration, web designer, graphic design, best web designs, website design"></meta>
          <link rel="canonical" href="https://sitesee.co"></link>
          <link rel="alternate" type="application/rss+xml" href="https://sitesee.co/feed" title="SiteSee"></link>
        </Head>
        <Header darkMode={this.props.darkMode} />
        <main>
          {children}
        </main>
        <Footer />
        <Modal />
        </ModalContext.Provider>
    )
  }
}

export default class MyApp extends App {
  static async getInitialProps({ Component, ctx }) {
    let darkModeStatus = false;

    const currentCookie = ctx.req && ctx.req.headers.cookie ? ctx.req.headers.cookie : '';

    if(currentCookie.includes('darkMode=true')) {
      darkModeStatus = true;
    }

    let pageProps = {}

    if (Component.getInitialProps) {
      pageProps = await Component.getInitialProps(ctx)
    }

    return { 
      pageProps,
      darkModeStatus,
    }
  }

  render () {
    const { Component, pageProps } = this.props;
    
    initGA();
    logPageView(this.props.router.asPath);

    return (
      <Container>
        <Layout darkMode={this.props.darkModeStatus}>
          <Component {...pageProps} />
        </Layout>
      </Container>
    )
  }
}